import React from 'react';

import cs from 'classnames';

import {PresenceConsumer} from './PresenceConsumer';
import {PresenceContextBoxes} from './PresenceContextBoxes';
import {PresenceSubscriber} from './PresenceSubscriber';

import type {ValidContextType} from 'app/presence/types';
import type {contentType} from 'js-libs/sweetcommons/contentType';

type Props = {
  contentType: contentType;
  objectId: string | number;
  containerClass?: string;
  pageContext?: string;
  contexts?: Array<ValidContextType>;
};

export const DocumentPresenceMembers = ({
  contexts = ['view', 'edit'],
  containerClass = 'col-12',
  contentType,
  objectId,
  pageContext,
}: Props) => (
  <PresenceSubscriber
    contentType={contentType}
    objectsIds={[objectId]}
    pageContext={pageContext}
  >
    <PresenceConsumer
      contentType={contentType}
      objectId={objectId}
      contextFilter={(context) =>
        context != null && contexts.indexOf(context) > -1
      }
    >
      {(contextsUsers) => (
        <div className="container">
          <div className="row">
            <PresenceContextBoxes
              className={cs(
                'document-detail d-flex justify-content-start',
                containerClass
              )}
              contexts={contexts}
              users={contextsUsers}
              contentType={contentType}
            />
          </div>
        </div>
      )}
    </PresenceConsumer>
  </PresenceSubscriber>
);
